import { useContext, useState, useMemo, useRef, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useGlobalStore, ModalContext } from '../../components/contexts';
import ValidateService from '../../services/ValidateService';
import BasicSurveyFirstController from '../../controllers/aia/BasicSurveyFirstController';
import ButtonPrint from '../../components/buttonComponents/ButtonPrint';

const numberList = [
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: '5', label: '5' },
  { value: '6', label: '6' },
  { value: '7', label: '7' },
  { value: '8', label: '8' },
  { value: '9', label: '9' },
  { value: '10', label: '10' },
  { value: '11', label: '11' },
  { value: '12', label: '12' },
];

const dateUnitList = [
  { value: 'Y', label: '년' },
  { value: 'M', label: '개월' },
];

const BasicSurveyFirst = () => {
  useEffect(() => {
    document.title = '유해요인조사관리 - 유해요인 기본조사표';
  }, []);

  const contentRef = useRef(null);

  const location = useLocation();
  const [pageParam, setPageParam] = useState(location.state?.rowData);

  const { store, updateStore } = useGlobalStore();
  const { modalService } = useContext(ModalContext);
  const validateService = new ValidateService(modalService);
  const naviagte = useNavigate();

  const [taskInfo, setTaskInfo] = useState({});
  const [saveParam, setSaveParam] = useState({
    eqpmntFlctnYn: 'N',
    eqpmntFlctnPrd: '',
    eqpmntFlctnUnit: '',
    eqpmntFlctnEtcMttr: '',
    taskQtyFlctnYn: 'N',
    taskQtyFlctnPrd: '',
    taskQtyFlctnUnit: '',
    taskQtyFlctnMttr: '',
    spdFlctnYn: 'N',
    spdFlctnPrd: '',
    spdFlctnUnit: '',
    spdFlctnMttr: '',
    bizFlctnYn: 'N',
    bizFlctnPrd: '',
    bizFlctnUnit: '',
    bizFlctnMttr: '',
    workLoad: '',
    workFreq: '',
  });

  const [btnActive, setBtnActive] = useState(false);

  const controller = useMemo(() => {
    return new BasicSurveyFirstController(
      { store, updateStore },
      { pageParam, setPageParam },
      { taskInfo, setTaskInfo },
      { saveParam, setSaveParam },
      modalService,
      validateService,
      naviagte
    );
  }, [store, modalService, validateService]);

  useEffect(() => {
    if (
      pageParam !== undefined &&
      pageParam !== null &&
      pageParam?.entSn !== undefined &&
      pageParam?.entSn !== null &&
      pageParam?.entSn !== '' &&
      pageParam?.aiaAplyId !== undefined &&
      pageParam?.aiaAplyId !== null &&
      pageParam?.aiaAplyId !== ''
    ) {
      controller.fnSearch();
    }
  }, [pageParam]);

  useEffect(() => {
    setPageParam({
      flag: location.state?.flag,
      entSn: location.state?.entSn,
      aiaAplyId: location.state?.aiaAplyId,
    });
  }, [location]);

  return (
    <>
      <div ref={contentRef}>
        <div className="page-title-wrap" data-type="responsive">
          <h2 className="h-tit">유해요인조사관리 - 유해요인 기본조사표</h2>
        </div>
        <div className="tbl-wrap">
          <table className="tbl data row">
            <colgroup></colgroup>
            <tbody>
              <tr>
                <th scope="row">공정</th>
                <td>
                  <div className="input-group">{taskInfo?.taskNm}</div>
                </td>
                <th scope="row">조사일자</th>
                <td>
                  <p>{taskInfo?.aplyYmd}</p>
                </td>
              </tr>
              <tr>
                <th scope="row">공정 상세내용</th>
                <td>
                  <p>{taskInfo?.taskExpln}</p>
                </td>
                <th scope="row">조사자</th>
                <td>
                  <p>{taskInfo?.aplyUser}</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <ol className="step-wrap">
          <li className="done">
            <span>
              <span className="step-tit">부담작업 체크리스트 작성</span>
            </span>
          </li>
          <li className="done">
            <span>
              <span className="step-tit">영상 업로드</span>
            </span>
          </li>
          <li className="done">
            <span>
              <span className="step-tit">AI영상분석신청</span>
            </span>
          </li>
          <li className="done">
            <span>
              <span className="step-tit">AI영상분석완료</span>
            </span>
          </li>
          <li className="active">
            <span>
              <em className="sr-only">현재단계</em>
              <span className="step-tit">유해요인 기본조사표 작성</span>
            </span>
          </li>
        </ol>
        <div className="tbl-wrap">
          <h3 className="block-tit">
            공정 작업장 상황 조사(동일 공정 내 1회 작성)
          </h3>
          <p className="tbl-msg">
            공정 작업장 내 변화가 있는 경우 작성해주세요.
          </p>
          <div className="tbl-scroll-box">
            <table className="tbl row data">
              <tbody>
                <tr>
                  <th>공정설비</th>
                  <td>
                    <div className="input-group">
                      <label
                        className="hidden-label"
                        htmlFor="eqpmntFlcntYn"
                        id="eqpmntFlcntYnLbl"
                      >
                        라벨
                      </label>
                      <select
                        className="form-select md"
                        id="eqpmntFlcntYn"
                        value={saveParam?.eqpmntFlctnYn}
                        onChange={e => {
                          controller.saveParamChange(
                            'eqpmntFlctnYn',
                            e.target.value
                          );
                        }}
                        aria-labelledby="eqpmntFlcntYnLbl"
                      >
                        <option value="Y">변화있음</option>
                        <option value="N">변화없음</option>
                      </select>
                      {'('}
                      <label
                        className="hidden-label"
                        htmlFor="eqpmntFlctnPrd"
                        id="eqpmntFlctnPrdLbl"
                      >
                        라벨
                      </label>
                      <select
                        id="eqpmntFlctnPrd"
                        className="form-select md"
                        value={saveParam?.eqpmntFlctnPrd}
                        onChange={e => {
                          controller.saveParamChange(
                            'eqpmntFlctnPrd',
                            e.target.value
                          );
                        }}
                        disabled={!(saveParam?.eqpmntFlctnYn === 'Y')}
                        aria-labelledby="eqpmntFlctnPrdLbl"
                      >
                        <option value="">선택</option>
                        {numberList.map(number => {
                          return (
                            <option key={number.value} value={number.value}>
                              {number.label}
                            </option>
                          );
                        })}
                      </select>
                      <label
                        className="hidden-label"
                        htmlFor="eqpmntFlctnUnit"
                        id="eqpmntFlctnUnitLbl"
                      >
                        라벨
                      </label>
                      <select
                        id="eqpmntFlctnUnit"
                        className="form-select md"
                        value={saveParam?.eqpmntFlctnUnit}
                        onChange={e => {
                          controller.saveParamChange(
                            'eqpmntFlctnUnit',
                            e.target.value
                          );
                        }}
                        disabled={!(saveParam?.eqpmntFlctnYn === 'Y')}
                        aria-labelledby="eqpmntFlctnUnitLbl"
                      >
                        <option value="">선택</option>
                        {dateUnitList.map(unit => {
                          return (
                            <option key={unit.value} value={unit.value}>
                              {unit.label}
                            </option>
                          );
                        })}
                      </select>
                      {'전부터)'}
                    </div>
                  </td>
                  <td>
                    <div className="input-group">
                      <label
                        className="hidden-label"
                        htmlFor="eqpmntFlctnEtcMttr"
                        id="eqpmntFlctnEtcMttrLbl"
                      >
                        라벨
                      </label>
                      <input
                        type="text"
                        id="eqpmntFlctnEtcMttr"
                        className="form-control md"
                        maxLength={66}
                        value={saveParam?.eqpmntFlctnEtcMttr}
                        onChange={e => {
                          controller.saveParamChange(
                            'eqpmntFlctnEtcMttr',
                            e.target.value
                          );
                        }}
                        disabled={!(saveParam?.eqpmntFlctnYn === 'Y')}
                        aria-labelledby="eqpmntFlctnEtcMttrLbl"
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>공정량</th>
                  <td>
                    <div className="input-group">
                      <label
                        className="hidden-label"
                        htmlFor="taskQtyFlctnYn"
                        id="taskQtyFlctnYnLbl"
                      >
                        라벨
                      </label>
                      <select
                        className="form-select md"
                        id="taskQtyFlctnYn"
                        value={saveParam?.taskQtyFlctnYn}
                        onChange={e => {
                          controller.saveParamChange(
                            'taskQtyFlctnYn',
                            e.target.value
                          );
                        }}
                        aria-labelledby="taskQtyFlctnYnLbl"
                      >
                        <option value="Y">변화있음</option>
                        <option value="N">변화없음</option>
                      </select>
                      {'('}
                      <label
                        className="hidden-label"
                        htmlFor="taskQtyFlctnPrd"
                        id="taskQtyFlctnPrdLbl"
                      >
                        라벨
                      </label>
                      <select
                        id="taskQtyFlctnPrd"
                        className="form-select md"
                        value={saveParam?.taskQtyFlctnPrd}
                        onChange={e => {
                          controller.saveParamChange(
                            'taskQtyFlctnPrd',
                            e.target.value
                          );
                        }}
                        disabled={!(saveParam?.taskQtyFlctnYn === 'Y')}
                        aria-labelledby="taskQtyFlctnPrdLbl"
                      >
                        <option value="">선택</option>
                        {numberList.map(number => {
                          return (
                            <option key={number.value} value={number.value}>
                              {number.label}
                            </option>
                          );
                        })}
                      </select>
                      <label
                        className="hidden-label"
                        htmlFor="taskQtyFlctnUnit"
                        id="taskQtyFlctnUnitLbl"
                      >
                        라벨
                      </label>
                      <select
                        id="taskQtyFlctnUnit"
                        className="form-select md"
                        value={saveParam?.taskQtyFlctnUnit}
                        onChange={e => {
                          controller.saveParamChange(
                            'taskQtyFlctnUnit',
                            e.target.value
                          );
                        }}
                        disabled={!(saveParam?.taskQtyFlctnYn === 'Y')}
                        aria-labelledby="taskQtyFlctnUnitLbl"
                      >
                        <option value="">선택</option>
                        {dateUnitList.map(unit => {
                          return (
                            <option key={unit.value} value={unit.value}>
                              {unit.label}
                            </option>
                          );
                        })}
                      </select>
                      {'전부터) 기타'}
                    </div>
                  </td>
                  <td>
                    <div className="input-group">
                      <label
                        className="hidden-label"
                        htmlFor="taskQtyFlctnMttr"
                        id="taskQtyFlctnMttrLbl"
                      >
                        라벨
                      </label>
                      <input
                        type="text"
                        id="taskQtyFlctnMttr"
                        className="form-control md"
                        maxLength={66}
                        value={saveParam?.taskQtyFlctnMttr}
                        onChange={e => {
                          controller.saveParamChange(
                            'taskQtyFlctnMttr',
                            e.target.value
                          );
                        }}
                        disabled={!(saveParam?.taskQtyFlctnYn === 'Y')}
                        aria-labelledby="taskQtyFlctnMttrLbl"
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>공정속도</th>
                  <td>
                    <div className="input-group">
                      <label
                        className="hidden-label"
                        htmlFor="spdFlctnYn"
                        id="spdFlctnYnLbl"
                      >
                        라벨
                      </label>
                      <select
                        className="form-select md"
                        id="spdFlctnYn"
                        value={saveParam?.spdFlctnYn}
                        onChange={e => {
                          controller.saveParamChange(
                            'spdFlctnYn',
                            e.target.value
                          );
                        }}
                        aria-labelledby="spdFlctnYnLbl"
                      >
                        <option value="Y">변화있음</option>
                        <option value="N">변화없음</option>
                      </select>
                      {'('}
                      <label
                        className="hidden-label"
                        htmlFor="spdFlctnPrd"
                        id="spdFlctnPrdLbl"
                      >
                        라벨
                      </label>
                      <select
                        className="form-select md"
                        id="spdFlctnPrd"
                        value={saveParam?.spdFlctnPrd}
                        onChange={e => {
                          controller.saveParamChange(
                            'spdFlctnPrd',
                            e.target.value
                          );
                        }}
                        disabled={!(saveParam?.spdFlctnYn === 'Y')}
                        aria-labelledby="spdFlctnPrdLbl"
                      >
                        <option value="">선택</option>
                        {numberList.map(number => {
                          return (
                            <option key={number.value} value={number.value}>
                              {number.label}
                            </option>
                          );
                        })}
                      </select>
                      <label
                        className="hidden-label"
                        htmlFor="spdFlctnUnit"
                        id="spdFlctnUnitLbl"
                      >
                        라벨
                      </label>
                      <select
                        className="form-select md"
                        id="spdFlctnUnit"
                        value={saveParam?.spdFlctnUnit}
                        onChange={e => {
                          controller.saveParamChange(
                            'spdFlctnUnit',
                            e.target.value
                          );
                        }}
                        disabled={!(saveParam?.spdFlctnYn === 'Y')}
                        aria-labelledby="spdFlctnUnitLbl"
                      >
                        <option value="">선택</option>
                        {dateUnitList.map(unit => {
                          return (
                            <option key={unit.value} value={unit.value}>
                              {unit.label}
                            </option>
                          );
                        })}
                      </select>
                      {'전부터) 기타'}
                    </div>
                  </td>
                  <td>
                    <div className="input-group">
                      <label
                        className="hidden-label"
                        htmlFor="spdFlctnMttr"
                        id="spdFlctnMttrLbl"
                      >
                        라벨
                      </label>
                      <input
                        type="text"
                        id="spdFlctnMttr"
                        className="form-control md"
                        maxLength={66}
                        value={saveParam?.spdFlctnMttr}
                        onChange={e => {
                          controller.saveParamChange(
                            'spdFlctnMttr',
                            e.target.value
                          );
                        }}
                        disabled={!(saveParam?.spdFlctnYn === 'Y')}
                        aria-labelledby="spdFlctnMttrLbl"
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>업무변화</th>
                  <td>
                    <div className="input-group">
                      <label
                        className="hidden-label"
                        htmlFor="bizFlctnYn"
                        id="bizFlctnYnLbl"
                      >
                        라벨
                      </label>
                      <select
                        id="bizFlctnYn"
                        className="form-select md"
                        value={saveParam?.bizFlctnYn}
                        onChange={e => {
                          controller.saveParamChange(
                            'bizFlctnYn',
                            e.target.value
                          );
                        }}
                        aria-labelledby="bizFlctnYnLbl"
                      >
                        <option value="Y">변화있음</option>
                        <option value="N">변화없음</option>
                      </select>
                      {'('}
                      <label
                        className="hidden-label"
                        htmlFor="bizFlctnPrd"
                        id="bizFlctnPrdLbl"
                      >
                        라벨
                      </label>
                      <select
                        id="bizFlctnPrd"
                        className="form-select md"
                        value={saveParam?.bizFlctnPrd}
                        onChange={e => {
                          controller.saveParamChange(
                            'bizFlctnPrd',
                            e.target.value
                          );
                        }}
                        disabled={!(saveParam?.bizFlctnYn === 'Y')}
                        aria-labelledby="bizFlctnPrdLbl"
                      >
                        <option value="">선택</option>
                        {numberList.map(number => {
                          return (
                            <option key={number.value} value={number.value}>
                              {number.label}
                            </option>
                          );
                        })}
                      </select>
                      <label
                        className="hidden-label"
                        htmlFor="bizFlctnUnit"
                        id="bizFlctnUnitLbl"
                      >
                        라벨
                      </label>
                      <select
                        id="bizFlctnUnit"
                        className="form-select md"
                        value={saveParam?.bizFlctnUnit}
                        onChange={e => {
                          controller.saveParamChange(
                            'bizFlctnUnit',
                            e.target.value
                          );
                        }}
                        disabled={!(saveParam?.bizFlctnYn === 'Y')}
                        aria-labelledby="bizFlctnUnitLbl"
                      >
                        <option value="">선택</option>
                        {dateUnitList.map(unit => {
                          return (
                            <option key={unit.value} value={unit.value}>
                              {unit.label}
                            </option>
                          );
                        })}
                      </select>
                      {'전부터) 기타'}
                    </div>
                  </td>
                  <td>
                    <div className="input-group">
                      <label
                        className="hidden-label"
                        htmlFor="bizFlctnMttr"
                        id="bizFlctnMttrLbl"
                      >
                        라벨
                      </label>
                      <input
                        id="bizFlctnMttr"
                        type="text"
                        className="form-control md"
                        maxLength={66}
                        value={saveParam?.bizFlctnMttr}
                        onChange={e => {
                          controller.saveParamChange(
                            'bizFlctnMttr',
                            e.target.value
                          );
                        }}
                        disabled={!(saveParam?.bizFlctnYn === 'Y')}
                        aria-labelledby="bizFlctnMttrLbl"
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="tbl-wrap">
          <h3 className="block-tit">단위공정 작업부하 및 작업 빈도</h3>
          <div className="tbl-scroll-box">
            <table className="tbl row data">
              <tbody>
                <tr>
                  <th rowspan="2">작업 부하 및 빈도</th>
                  <th className="bg1">부하</th>
                  <td>
                    <div className="chk-area">
                      <div className="form-check">
                        <input
                          type="radio"
                          name={'workLoad'}
                          id={`${true}_rdo1_ans1`}
                          value="VE"
                          checked={saveParam?.workLoad === 'VE'}
                          onChange={e => {
                            controller.saveParamChange(
                              'workLoad',
                              e.target.value
                            );
                          }}
                          aria-labelledby={`${true}_rdo1_ans1Lbl`}
                        />
                        <label
                          htmlFor={`${true}_rdo1_ans1`}
                          id={`${true}_rdo1_ans1Lbl`}
                        >
                          매우 쉬움
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          type="radio"
                          name={'workLoad'}
                          id={`${true}_rdo1_ans2`}
                          value="E"
                          checked={saveParam?.workLoad === 'E'}
                          onChange={e => {
                            controller.saveParamChange(
                              'workLoad',
                              e.target.value
                            );
                          }}
                          aria-labelledby={`${true}_rdo1_ans2Lbl`}
                        />
                        <label
                          htmlFor={`${true}_rdo1_ans2`}
                          id={`${true}_rdo1_ans2Lbl`}
                        >
                          쉬움
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          type="radio"
                          name={'workLoad'}
                          id={`${true}_rdo1_ans3`}
                          value="LH"
                          checked={saveParam?.workLoad === 'LH'}
                          onChange={e => {
                            controller.saveParamChange(
                              'workLoad',
                              e.target.value
                            );
                          }}
                          aria-labelledby={`${true}_rdo1_ans3Lbl`}
                        />
                        <label
                          htmlFor={`${true}_rdo1_ans3`}
                          id={`${true}_rdo1_ans3Lbl`}
                        >
                          약간 힘듦
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          type="radio"
                          name={'workLoad'}
                          id={`${true}_rdo1_ans4`}
                          value="H"
                          checked={saveParam?.workLoad === 'H'}
                          onChange={e => {
                            controller.saveParamChange(
                              'workLoad',
                              e.target.value
                            );
                          }}
                          aria-labelledby={`${true}_rdo1_ans4Lbl`}
                        />
                        <label
                          htmlFor={`${true}_rdo1_ans4`}
                          id={`${true}_rdo1_ans4Lbl`}
                        >
                          힘듦
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          type="radio"
                          name={'workLoad'}
                          id={`${true}_rdo1_ans5`}
                          value="VH"
                          checked={saveParam?.workLoad === 'VH'}
                          onChange={e => {
                            controller.saveParamChange(
                              'workLoad',
                              e.target.value
                            );
                          }}
                          aria-labelledby={`${true}_rdo1_ans5Lbl`}
                        />
                        <label
                          htmlFor={`${true}_rdo1_ans5`}
                          id={`${true}_rdo1_ans5Lbl`}
                        >
                          매우 힘듦
                        </label>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th className="bg1">빈도</th>
                  <td>
                    <div className="chk-area">
                      <div className="form-check">
                        <input
                          type="radio"
                          name={'workFreq'}
                          id={`${false}_rdo2_ans1`}
                          value="ETM"
                          checked={saveParam?.workFreq === 'ETM'}
                          onChange={e => {
                            controller.saveParamChange(
                              'workFreq',
                              e.target.value
                            );
                          }}
                          aria-labelledby={`${true}_rdo2_ans5Lbl`}
                        />
                        <label
                          htmlFor={`${false}_rdo2_ans1`}
                          id={`${true}_rdo2_ans1Lbl`}
                        >
                          3개월마다(년2~3회)
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          type="radio"
                          name={'workFreq'}
                          id={`${false}_rdo2_ans2`}
                          value="EWOTT"
                          checked={saveParam?.workFreq === 'EWOTT'}
                          onChange={e => {
                            controller.saveParamChange(
                              'workFreq',
                              e.target.value
                            );
                          }}
                          aria-labelledby={`${true}_rdo2_ans5Lbl`}
                        />
                        <label
                          htmlFor={`${false}_rdo2_ans2`}
                          id={`${true}_rdo2_ans2Lbl`}
                        >
                          가끔(하루 또는 주 2~3일)
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          type="radio"
                          name={'workFreq'}
                          id={`${false}_rdo2_ans3`}
                          value="EDBFH"
                          checked={saveParam?.workFreq === 'EDBFH'}
                          onChange={e => {
                            controller.saveParamChange(
                              'workFreq',
                              e.target.value
                            );
                          }}
                          aria-labelledby={`${true}_rdo2_ans5Lbl`}
                        />
                        <label
                          htmlFor={`${false}_rdo2_ans3`}
                          id={`${true}_rdo2_ans3Lbl`}
                        >
                          자주(1일 4시간)
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          type="radio"
                          name={'workFreq'}
                          id={`${false}_rdo2_ans4`}
                          value="EDOFH"
                          checked={saveParam?.workFreq === 'EDOFH'}
                          onChange={e => {
                            controller.saveParamChange(
                              'workFreq',
                              e.target.value
                            );
                          }}
                          aria-labelledby={`${true}_rdo2_ans5Lbl`}
                        />
                        <label
                          htmlFor={`${false}_rdo2_ans4`}
                          id={`${true}_rdo2_ans4Lbl`}
                        >
                          계속(1일 4시간 이상)
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          type="radio"
                          name={'workFreq'}
                          id={`${false}_rdo2_ans5`}
                          value="EDOEH"
                          checked={saveParam?.workFreq === 'EDOEH'}
                          onChange={e => {
                            controller.saveParamChange(
                              'workFreq',
                              e.target.value
                            );
                          }}
                          aria-labelledby={`${true}_rdo2_ans5Lbl`}
                        />
                        <label
                          htmlFor={`${false}_rdo2_ans5`}
                          id={`${true}_rdo2_ans5Lbl`}
                        >
                          초과근무 시간(1일 8시간 이상)
                        </label>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="page-btn-wrap both">
        <div className="form-check">
          <input
            type="checkbox"
            id="chk_01"
            value="Y"
            checked={btnActive === 'Y'}
            onChange={e => {
              if (btnActive === 'Y') {
                setBtnActive('N');
              } else {
                setBtnActive('Y');
              }
            }}
          />
          <label for="chk_01">해당 내용을 작업정보에 저장합니다.</label>
        </div>
        <div className="btn-group">
          {btnActive === 'Y' ? (
            <ButtonPrint
              buttonName="인쇄"
              printRef={contentRef}
              landScape={true}
              disabled={false}
            />
          ) : (
            <ButtonPrint
              buttonName="인쇄"
              printRef={contentRef}
              landScape={true}
              disabled={true}
            />
          )}
          {btnActive === 'Y' ? (
            <button
              type="button"
              className="btn xlg primary"
              onClick={() => {
                controller.fnSave();
              }}
            >
              다음
            </button>
          ) : (
            <button type="button" className="btn xlg primary" disabled>
              다음
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default BasicSurveyFirst;
